export function convertToSubscriptionParams(provider, data) {
	return provider == 'stripe' ? convertToStripeSubscriptionParams(data) : convertToBraintreeSubscriptionParams(data)
}

export function convertToPurchaseParams(provider, data) {
	return provider == 'stripe' ? convertToStripePurchaseParams(data) : convertToBraintreePurchaseParams(data)
}

/**
 * Braintree
 */
export function convertToBraintreeSubscriptionParams(data) {
	return {
		trial_days: data.trial_days,
		trial_price: 0,
		regular_interval_month_count: data.duration_months,
		regular_price: data.product_price,
		currency: data.currency,
		payment_method_nonce: data.payment_method_nonce,
		service: 'android_pro'
	}
}

export function convertToBraintreePurchaseParams(data) {
	return {
		user_id: data.user_id,
		price_amount: data.product_price,
		price_currency: data.currency,
		service: 'android_pro'
	}
}

/**
 * Stripe
 */
export function convertToStripeSubscriptionParams(data) {
	return {
		trial_period_days: data.trial_days,
		trial_period_amount: 0,
		regular_period_interval: 'month',
		regular_period_interval_count: data.duration_months,
		regular_period_amount: data.product_price,
		payment_method_id: data.payment_method_id,
		currency: data.currency,
		product_id: data.stripe_product_id,
		intro_period_interval: 'month',
		intro_period_interval_count: 0,
		intro_period_amount: 0
	}
}

export function convertToStripePurchaseParams(data) {
	return {
		user_id: data.user_id,
		amount: data.product_price,
		currency: data.currency,
		email: data.email,
		payment_method_id: data.payment_method_id
	}
}
